import type { DomainMapper } from '../types';

const us: DomainMapper = {
  countryCode: 'us',
  currency: 'USD',
  dataAreaId: 'us40',
  domain: 'kahrs-stage.iveo.store',
  environment: 'stage',
  flagUrl: '/flags/US.svg',
  languagePrimary: true,
  locale: 'en-us',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-us.xml',
  storyblokBasePath: 'us',
  url: 'https://kahrs-stage.iveo.store/us',
  algoliaIndex: 'b2b-us-en-US-products',
  algoliaIndexAutocomplete: 'b2b-us-en-US-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1353,
  subFolder: true,
  measurement: 'imperial',
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1353,
    algoliaIndex: 'b2b-us-en-US-products',
    algoliaIndexAutocomplete: 'b2b-us-en-US-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/product',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-us.xml',
  },
  b2c: {
    enabled: true,
    productBasePath: 'product',
    storyblokBasePath: '',
    applicationId: 1353,
    algoliaIndex: 'b2c-us-en-US-products',
    algoliaIndexAutocomplete: 'b2c-us-en-US-products_query_suggestions',
    displayIncVat: true,
    default: true,
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-us-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
  },
  norceCdnBaseUrl: 'https://kahrs.stage.cdn-norce.tech',
} as DomainMapper;

export default us;
